module.exports = __webpack_public_path__ + "img/zz12.2dc548fe.png";